import { motion } from 'framer-motion';
import './MoodSelector.css';

const MoodSelector = ({ moods, onSelect }) => {
  return (
    <div className="mood-selector">
      {Object.values(moods).map((mood) => (
        <motion.button
          key={mood.value}
          className="mood-button"
          onClick={() => onSelect(mood)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <span className="mood-emoji">{mood.emoji}</span>
          <span className="mood-label">{mood.label}</span>
        </motion.button>
      ))}
    </div>
  );
};

export default MoodSelector; 